import { cloneElement } from 'react';
import TicketSummaryModal from 'flow/components/tickets/Ai/TicketSummaryModal';
import TicketTagsModal from 'flow/components/tickets/Ai/TicketTagsModal';
import CallTranscriptModal from 'flow/components/tickets/event-item/CallTranscriptModal';
import TicketCreateViaQueueCallModal from 'flow/components/tickets/Creation/TicketCreateViaQueueCallModal';
import TicketAttachmentNotAllowedDialog from 'flow/components/tickets/Input/Attachments/NotAllowedDialog/TicketAttachmentNotAllowedDialog';
import TicketOverviewModal from 'flow/components/tickets/TicketOverviewModal';
import AddTicketMembersModal from 'flow/components/tickets/ticket-details/AddMembers/AddTicketMembersModal';
import TicketMembersModal from 'flow/components/tickets/ticket-info-section/members/TicketMembersModal';
import TicketAccessModal from 'flow/components/tickets/ticket-info-section/access/TicketAccessModal';
import PremadeAnswerTicketModal from 'flow/components/tickets/PremadeAnswerTicketModal';
import WhatsAppTemplateModal from 'flow/components/tickets/WhatsAppTemplateModal';
import { useModal } from 'flow/contexts/ModalProvider';
import ChatPostModal from 'flow/pages/messages/ChatPostModal';
import ImagePreviewModal from 'flow/pages/messages/ImagePreviewModal';
import ChatSummaryModal from './ChatSummaryModal';
import GenerateChatSummaryModal from './GenerateChatSummaryModal';
import DashboardCreatedDialog from '../dashboard/DashboardCreatedDialog';
import AddLiveChatMemberModal from './AddLiveChatMemberModal';
import AddMessageMemberModal from './AddMessageMemberModal';
import AddQueueMemberModal from './AddQueueMemberModal';
import AddQueueWaveMemberModal from './AddQueueWaveMemberModal';
import AddVideoParticipantModal from './AddVideoParticipantModal';
import ArchivedChatsModal from './ArchivedChatsModal';
import CallRecordContactModal from './CallRecordContactModal';
import ContactModal from './ContactModal';
import TicketContactModal from './TicketContactModal';
import CreateCalendarEventModal from './CreateCalendarEventModal';
import CreateCallRoutingModal from './CreateCallRoutingModal';
import CreateContactModal from './CreateContactModal';
import CreateMeetingRoomModal from './VideoMeetingRoom/CreateMeetingRoomModal';
import RoomCreatedModal from './VideoMeetingRoom/RoomCreatedModal';
import CreateFlowFreeProfileModal from './CreateFlowFreeProfileModal';
import CreatePostModal from './CreatePostModal';
import PremadeAnswerModal from './PremadeAnswerModal';
import CreateProfileModal from './CreateProfileModal';
import CreateTokenModal from './CreateTokenModal';
import CentralSwitchWidgetDialog from './dialogs/CentralSwitchWidgetDialog';
import AccessDeniedDialog from './dialogs/AccessDeniedDialog';
import ConfirmationDialog from './dialogs/ConfirmationDialog';
import CreateTokenSuccessDialog from './dialogs/CreateTokenSuccessDialog';
import DeleteContactDialog from './dialogs/DeleteContactDialog';
import MessageAttachmentTooLargeDialog from './dialogs/MessageAttachmentTooLargeDialog';
import RemoveDialog from './dialogs/RemoveDialog';
import RevokeTokenDialog from './dialogs/RevokeTokenDialog';
import DurationPickerModal from './DurationPickerModal';
import EditCalendarEventModal from './EditCalendarEventModal';
import EditContactModal from './EditContactModal';
import EditSoundModal from './EditSoundModal';
import ImageTicketsModal from './ImageTicketsModal';
import IncomingCallsModal from './IncomingCallsModal';
import InviteColleagueModal from './InviteColleagueModal';
import ListRoomsModal from './ListRoomsModal';
import ManagePublicRoomModal from './ManagePublicRoomModal';
import ManageRoomModal from './ManageRoomModal';
import MobileDataStatisticsModal from './MobileDataStatisticsModal';
import MuteConversationModal from './MuteConversationModal';
import NumberPickerModal from './NumberPickerModal';
import OpeningHourModal from './OpeningHourModal';
import ProfilePickerModal from './ProfilePickerModal';
import ReactionsModal from './ReactionsModal';
import TranscriptionDetailModal from './TranscriptionDetailModal';
import AddAiMode from './AddAiMode';
import CreateSoundModal from './CreateSoundModal';
import EditKeyboardShortcutModal from './EditKeyboardShortcutModal';
import MeetingLobbyOpenInAppDialog from '../dialogs/MeetingLobbyOpenInAppDialog';
import AddExtensionsToAutoCoListenToModal from 'flow/components/central-switch/central-switch-widgets/CoListeningAutoWidgetAlpha/AddExtensionsToAutoCoListenToModal';
import CallRecordDetailModalV2 from './CallRecordDetailModalV2';
import ModalTranscription from './transcription/ModalTranscription';
import ModalTicketStateChangeV2 from './dialogs/ModalTicketStateChangeV2';
import DialogDeleteRecording from 'flow/components/pbx/v2/detail-page/call-event/RecordingContextMenu/DialogDeleteRecording';
import DialogDeleteExtendedTranscription from 'flow/components/pbx/v2/detail-page/call-event/RecordingContextMenu/DialogDeleteExtendedTranscription';
import UserRegionSelectorModal from './UserRegionSelectorModal';
import InstantMeetingModal from './InstantMeetingModal';

export const modalComponents = {
    addLiveChatMember: <AddLiveChatMemberModal />,
    addQueueMember: <AddQueueMemberModal />,
    addQueueWaveMember: <AddQueueWaveMemberModal />,
    listRooms: <ListRoomsModal />,
    managePublicRoom: <ManagePublicRoomModal />,
    manageRoom: <ManageRoomModal />,
    createCallRouting: <CreateCallRoutingModal />,
    createFlowFreeProfile: <CreateFlowFreeProfileModal />,
    createProfile: <CreateProfileModal />,
    premadeAnswer: <PremadeAnswerModal />,
    premadeAnswerTicket: <PremadeAnswerTicketModal />,
    muteConversation: <MuteConversationModal />,
    chatPost: <ChatPostModal />,
    imageTickets: <ImageTicketsModal />,
    imagePreview: <ImagePreviewModal />,
    createPost: <CreatePostModal />,
    setOpeningHour: <OpeningHourModal />,
    setProfileUntil: <ProfilePickerModal />,
    addMessageMember: <AddMessageMemberModal />,
    archivedChats: <ArchivedChatsModal />,
    createCalendarEvent: <CreateCalendarEventModal />,
    createToken: <CreateTokenModal />,
    createTokenSuccess: <CreateTokenSuccessDialog />,
    editCalendarEvent: <EditCalendarEventModal />,
    revokeToken: <RevokeTokenDialog />,
    numberPicker: <NumberPickerModal />,
    contactModal: <ContactModal />,
    callRecordContactModal: <CallRecordContactModal />,
    ticketContactModal: <TicketContactModal />,
    createContact: <CreateContactModal />,
    createMeetingRoom: <CreateMeetingRoomModal />,
    roomCreated: <RoomCreatedModal />,
    editContact: <EditContactModal />,
    inviteColleague: <InviteColleagueModal />,
    messageAttachmentTooLarge: <MessageAttachmentTooLargeDialog />,
    mobileDataStatistics: <MobileDataStatisticsModal />,
    deleteContact: <DeleteContactDialog />,
    durationPicker: <DurationPickerModal />,
    transcriptionDetail: <TranscriptionDetailModal />,
    reactions: <ReactionsModal />,
    confirmationDialog: <ConfirmationDialog />,
    accessDenied: <AccessDeniedDialog />,
    removeDialog: <RemoveDialog />,
    ticketCreateViaQueueCall: <TicketCreateViaQueueCallModal />,
    ticketOverview: <TicketOverviewModal />,
    ticketTags: <TicketTagsModal />,
    addTicketMembers: <AddTicketMembersModal />,
    ticketMembers: <TicketMembersModal />,
    ticketAccess: <TicketAccessModal />,
    callTranscript: <CallTranscriptModal />,
    ticketAttachmentNotAllowed: <TicketAttachmentNotAllowedDialog />,
    ticketSummary: <TicketSummaryModal />,
    whatsAppTemplate: <WhatsAppTemplateModal />,
    centralSwitchWidget: <CentralSwitchWidgetDialog />,
    incomingCall: <IncomingCallsModal />,
    dashboardCreated: <DashboardCreatedDialog />,
    addVideoParticipant: <AddVideoParticipantModal />,
    addAiMode: <AddAiMode />,
    createSound: <CreateSoundModal />,
    editSound: <EditSoundModal />,
    editKeyboardShortcut: <EditKeyboardShortcutModal />,
    openMeetingInApp: <MeetingLobbyOpenInAppDialog />,
    generateChatSummary: <GenerateChatSummaryModal />,
    chatSummary: <ChatSummaryModal />,
    addExtensionsToAutoCoListenToModal: <AddExtensionsToAutoCoListenToModal />,
    callRecordDetailV2: <CallRecordDetailModalV2 />,
    ticketStateChangeV2: <ModalTicketStateChangeV2 />,
    transcription: <ModalTranscription />,
    deleteRecording: <DialogDeleteRecording />,
    deleteTranscription: <DialogDeleteExtendedTranscription />,
    userRegionSelectorModal: <UserRegionSelectorModal />,
    instantMeeting: <InstantMeetingModal />,
};

const Modals = () => {
    const { modals } = useModal();

    if (!modals.length) {
        return null;
    }

    const { name, ...rest } = modals[modals.length - 1];

    return cloneElement(modalComponents[name], rest);
};

export default Modals;
